import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AppConstant } from '../../app.constants';
import { LoaderService } from 'src/app/shared/services/loader.service';
import { CommonServiceHelper } from './commonHelper.service';
import { ConfirmDialogComponent } from '../../confirm-dialog/confirm-dialog.component';
import { CustomDialogComponent } from '../custom-dialog/custom-dialog.component';
import { Observable, finalize } from 'rxjs';
import { IResponse } from 'src/app/Models/response.model';

@Injectable()
export class CommonLookupData {

    constructor(private _appConstant: AppConstant,
        private _loaderService: LoaderService,
        private _toasterService: ToastrService,
        private _commonServiceHelper: CommonServiceHelper,
        private dialog: MatDialog,
        private ngbModal: NgbModal) {
    }

    public moduleNameEnum = {
        Users: "Users", Locations: "Locations", Sampling_Plans: "Sampling Plans", Cases: "Cases", Reports: "Reports", Programs: "Programs", InsightMenu: "InsightMenu",
        MIMSUser: "MIMS_MobileUsers", Shipments: 'MIMS_Shipments', Decantings: 'MIMS_Decantings', ContainerDisposals: 'MIMS_ContainerDisposals', LockerAccess: 'MIMS_LockerAccess',
        Dispatch: 'MIMS_Dispatch', InventoryChecks: 'MIMS_InventoryChecks', MarkingOperations: 'MIMS_MarkingOperations', Resources: 'MIMS_Resources', MarkingFieldTests: 'MIMS_MarkingFieldTests',
        MIMSRoles: 'MIMS_MobileRoles', RemoteCommand: 'MIMS_RemoteCommand'
    };
    public moduleActionEnum = { View: "View", Add: "Add", Edit: "Edit", Delete: "Delete" };

    getCountry(callback) {
        if (this._appConstant.country && this._appConstant.country.length === 0) {
            //this._loaderService.display(true);
            this._commonServiceHelper.getProgramCountry()
                .pipe(
      finalize(() => {
                    //this._loaderService.display(false);
                }))
                .subscribe(
                    (res: any) => {

                        if (res && res.data) {
                            this._appConstant.country = res.data;
                            callback(res.data)
                        }
                    },
                    (error: any) => {
                        this._toasterService.error(error.message, 'Error');
                    }
                );
        } else {
            callback(this._appConstant.country)
        }
    }

    getCountryByProgram(callback) {
        if (this._appConstant.country && this._appConstant.country.length === 0) {
            //this._loaderService.display(true);
            this._commonServiceHelper.getProgramCountries()
                .pipe(
      finalize(() => {
                    //this._loaderService.display(false);
                }))
                .subscribe(
                    (res: any) => {

                        if (res && res.data) {
                            this._appConstant.country = res.data;
                            callback(res.data)
                        }
                    },
                    (error: any) => {
                        this._toasterService.error(error.message, 'Error');
                    }
                );
        } else {
            callback(this._appConstant.country)
        }
    }

    getProgramType(callback) {
        if (this._appConstant.ProgramType && this._appConstant.ProgramType.length === 0) {
            this._loaderService.display(true);
            this._commonServiceHelper.getProgramType()
                .pipe(
      finalize(() => {
                    this._loaderService.display(false);
                }))
                .subscribe(
                    (res: any) => {
                        if (res && res.data) {
                            this._appConstant.ProgramType = res.data;
                            callback(res.data)
                        }
                    },
                    (error: any) => {
                        this._toasterService.error(error.message, 'Error');
                    }
                );
        } else {
            callback(this._appConstant.ProgramType)
        }
    }

    getProductType(callback) {
        if (this._appConstant.ProductType && this._appConstant.ProductType.length === 0) {
            this._loaderService.display(true);
            this._commonServiceHelper.getProductType()
                .pipe(
      finalize(() => {
                    this._loaderService.display(false);
                }))
                .subscribe(
                    (res: any) => {
                        if (res) {
                            this._appConstant.ProductType = res.data;
                            callback(res.data);
                        }
                    },
                    (error: any) => {
                        this._toasterService.error(error.message, 'Error');
                    }
                );
        } else {
            callback(this._appConstant.ProductType);
        }
    }

    getProductCategory(callback) {
        if (this._appConstant.ProductCategory && this._appConstant.ProductCategory.length === 0) {
            this._loaderService.display(true);
            this._commonServiceHelper.getProductCategory()
                .pipe(
      finalize(() => {
                    this._loaderService.display(false);
                }))
                .subscribe(
                    (res: any) => {
                        if (res) {
                            this._appConstant.ProductCategory = res.data;
                            callback(res.data);
                        }
                    },
                    (error: any) => {
                        this._toasterService.error(error.message, 'Error');
                    }
                );
        } else {
            callback(this._appConstant.ProductCategory);
        }
    }

    getConcentrationUnits(callback) {
        if (this._appConstant.ConcentrationUnits && this._appConstant.ConcentrationUnits.length === 0) {
            this._loaderService.display(true);
            this._commonServiceHelper.getConcentrationUnits()
                .pipe(
      finalize(() => {
                    this._loaderService.display(false);
                }))
                .subscribe(
                    (res: any) => {
                        if (res) {
                            this._appConstant.ConcentrationUnits = res.data;
                            callback(res.data);
                        }
                    },
                    (error: any) => {
                        this._toasterService.error(error.message, 'Error');
                    }
                );
        } else {
            callback(this._appConstant.ConcentrationUnits);
        }
    }

    getDosingLevelUnits(callback) {
        if (this._appConstant.DosingLevelUnits && this._appConstant.DosingLevelUnits.length === 0) {
            this._loaderService.display(true);
            this._commonServiceHelper.getDosingLevelUnits()
                .pipe(
      finalize(() => {
                    this._loaderService.display(false);
                }))
                .subscribe(
                    (res: any) => {
                        if (res) {
                            this._appConstant.DosingLevelUnits = res.data;
                            callback(res.data);
                        }
                    },
                    (error: any) => {
                        this._toasterService.error(error.message, 'Error');
                    }
                );
        } else {
            callback(this._appConstant.DosingLevelUnits);
        }
    }

    getLanguage(callback) {
        if (this._appConstant.programUserLanguage && this._appConstant.programUserLanguage.length === 0) {
            //this._loaderService.display(true);
            this._commonServiceHelper.getLanguageList()
                .pipe(
      finalize(() => {
                    //this._loaderService.display(false);
                }))
                .subscribe(
                    (res: any) => {
                        if (res && res.data) {
                            this._appConstant.programUserLanguage = res.data;
                            callback(res.data);
                        }
                    },
                    (error: any) => {
                        this._toasterService.error(error.message, 'Error');
                    }
                );
        } else {
            callback(this._appConstant.programUserLanguage);
        }
    }

    getProgramUserRoles(callback) {
        // if (this._appConstant.programUserRoles && this._appConstant.programUserRoles.length === 0) {
        this._loaderService.display(true);
        this._commonServiceHelper.getRoleList(this._appConstant.programId)
            .pipe(
      finalize(() => {
                this._loaderService.display(false);
            }))
            .subscribe(
                (res: any) => {
                    if (res && res.data) {
                        this._appConstant.programUserRoles = res.data;
                        callback(res.data);
                    }
                },
                (error: any) => {
                    this._toasterService.error(error.message, 'Error');
                }
            );
        // } else {
        //     callback(this._appConstant.programUserRoles);
        // }
    };

    getProgramDetaSource(callback) {
        // if (this._appConstant.programDataSource && this._appConstant.programDataSource.length === 0) {
        this._commonServiceHelper.getProgramDataSource()
            .pipe(
      finalize(() => {
            }))
            .subscribe(
                (res: any) => {
                    if (res && res.data) {
                        this._appConstant.programDataSource = res.data;
                        callback(res.data)
                    }
                },
                (error: any) => {
                    this._toasterService.error(error.message, 'Error');
                }
            );
        // } else {
        //     callback(this._appConstant.programDataSource)
        // }
    }

    confirmDialog(cnfText, callback) {
        const dialogConfig = new MatDialogConfig();

        dialogConfig.disableClose = true;
        dialogConfig.autoFocus = true;
        dialogConfig.height = 'auto';
        dialogConfig.width = '30%';
        dialogConfig.data = { message: cnfText, showCommonPopup: false, showOnlyConfirmButton: false };

        const dialogRef = this.dialog.open(ConfirmDialogComponent, dialogConfig);

        dialogRef.afterClosed().subscribe(result => {
            if (this._appConstant.mimsdeleteConfirmIndex != -1) {
                const el = document.querySelectorAll('.mat-mdc-row')[this._appConstant.mimsdeleteConfirmIndex];
                if (el && el.classList) {
                    el.classList.remove('active');
                }
            }
            callback(result);
        });
    }

    customConfirm(cnfText, callback) {
        const dialogConfig = new MatDialogConfig();

        dialogConfig.disableClose = true;
        dialogConfig.autoFocus = true;
        dialogConfig.height = 'auto';
        dialogConfig.width = '520px';
        dialogConfig.data = { message: cnfText, showCommonPopup: true, showOnlyConfirmButton: false };

        const dialogRef = this.dialog.open(ConfirmDialogComponent, dialogConfig);

        dialogRef.afterClosed().subscribe(result => {
            callback(result);
        });
    }

    confirm(message?: string) {
        const m = this.ngbModal.open(CustomDialogComponent, { centered: true });
        m.componentInstance.confMessage = message;
        return m.result;
    };

    public manageControlSecurity(moduleName: string, action?: string): boolean {
        let isAccessible = false;
        //Check role Context access for admin  
        if (this._appConstant.userDetail.roleContext == this._appConstant.roleContext.Admin && this._appConstant.logInAsProgramContext == false) {
            switch (moduleName) {
                case this.moduleNameEnum.Users:
                case this.moduleNameEnum.Programs:
                    isAccessible = true;
                    break;
                default:
                    isAccessible = false;
                    break;
            }
            return isAccessible;
        }
        //Check role context access for user
        if (this._appConstant.userModuleAccessDatasource && this._appConstant.userModuleAccessDatasource.length > 0) {
            let matchModuleName = this._appConstant.userModuleAccessDatasource.find(x => x.moduleCode === moduleName);
            //Check module lavel 
            if (!action && matchModuleName) {
                isAccessible = true;
            }
            //Check module action lavel
            if (action && matchModuleName) {
                switch (action.toLowerCase()) {
                    case "view":
                        isAccessible = matchModuleName.view;
                        break;
                    case "add":
                        isAccessible = matchModuleName.add;
                        break;
                    case "edit":
                        isAccessible = matchModuleName.edit;
                        break;
                    case "delete":
                        isAccessible = matchModuleName.delete;
                        break;
                    default:
                        isAccessible = false;
                        break;
                }
            }
        }
        return isAccessible;
    };

    public manageControlSecurityByUser(userId: string): boolean {
        return this._appConstant.userDetail.userId == userId;
    }

    public checkLogInAsProgramContext(isProgramContext: boolean): boolean {
        if (isProgramContext)
            return this._appConstant.userDetail.roleContext == this._appConstant.roleContext.Admin && this._appConstant.logInAsProgramContext == false;
        else {
            if (this._appConstant.logInAsProgramContext)
                return true;
            else
                return this._appConstant.userDetail.roleContext != this._appConstant.roleContext.Admin;
        }
    }

    public GetSamplingEndDate(startDate: Date, noOfWorkingDays: number): any {
        var date = startDate;
        for (var i = 0; i < noOfWorkingDays;) {
            date.setDate(date.getDate() + 1);
            if (!(date.getDay() % 6)) continue;
            i++;
        }
        return date;
    };

    public GetEstimatedAnalyzedDate(startDate: Date, noOfWorkingDays: number): any {
        var daysToBeAdd = noOfWorkingDays + (noOfWorkingDays > 5 ? 2 : 1) + (noOfWorkingDays > 5 ? 3 : 1);
        return this.GetSamplingEndDate(startDate, daysToBeAdd);
    };

    public GetEstimatedReceivedDate(startDate: Date, noOfWorkingDays: number): any {
        var daysToBeAdd = noOfWorkingDays + (noOfWorkingDays > 5 ? 2 : 1);
        return this.GetSamplingEndDate(startDate, daysToBeAdd);
    };

    public searchKeyWord(search: any): Observable<IResponse> {
        return this._commonServiceHelper.searchKeyWord(search);
    };

    public AddFileReaderPrototype(reader: FileReader) {
        if (this.IsIE() && !FileReader.prototype.readAsBinaryString) {
            FileReader.prototype.readAsBinaryString = function (fileData) {
                reader.readAsArrayBuffer(fileData);
            }
        }
    };

    public IsIE(): boolean {
        var ua = window.navigator.userAgent.toLowerCase();
        return ua.match(/msie|trident\/7/) ? true : false;
    };

    GetToken(callback) {
        var tempAccessToken = localStorage.getItem("powerbiAccessToken");
        if (!tempAccessToken || this._appConstant.TokenExpiresIn < new Date()) {
            this._loaderService.display(true);
            this._commonServiceHelper.GetToken().pipe(
      finalize(() => { this._loaderService.display(false); }))
                .subscribe((res: any) => {
                    if (res && res.access_Token) {
                        localStorage.setItem("powerbiAccessToken", res.access_Token);
                        var _tepmDate = new Date();
                        _tepmDate.setSeconds(3000);
                        this._appConstant.TokenExpiresIn = _tepmDate;
                        callback(res.access_Token);
                    } else {
                        this._appConstant.TokenExpiresIn = new Date();
                        localStorage.removeItem("powerbiAccessToken");
                        callback(false);
                    }
                },
                    (error: any) => {
                        this._toasterService.error(error.message, 'Error');
                        this._appConstant.TokenExpiresIn = new Date();
                        localStorage.removeItem("powerbiAccessToken");
                        callback(false);
                    });
        } else {
            callback(tempAccessToken);
        }
    };

    getAdminDashboardReport(callback) {
        this._loaderService.display(true);
        this._commonServiceHelper.getAdminDashboardReport()
            .pipe(
      finalize(() => {
                this._loaderService.display(false);
            }))
            .subscribe((res: any) => {
                callback(res);
            },
                (error: any) => {
                    this._toasterService.error(error.message, 'Error');
                    callback(false);
                });
    };

    getUserDashboardReport(callback) {
        this._loaderService.display(true);
        this._commonServiceHelper.getUserDashboardReport()
            .pipe(
      finalize(() => {
                this._loaderService.display(false);
            }))
            .subscribe((res: any) => {
                callback(res);
            },
                (error: any) => {
                    this._toasterService.error(error.message, 'Error');
                    callback(false);
                });
    };

    removeMaskValueOnly(event: any) {
        if (event && (event.keyCode == 8 || event.key == 'Backspace') && event.target.value.length == 6 && event.target.value.indexOf(')-') != -1) {
            event.target.value = event.target.value.replace('-', '');
        }
    };

    validatePhoneNumberInput(event: KeyboardEvent): void {
        const allowedKeys = [
            'Backspace', 'Tab', 'ArrowLeft', 'ArrowRight', 'Delete',
            ' ', '-', // space and dash
        ];

        // Allow Ctrl + A (Select All)
        if ((event.ctrlKey || event.metaKey) && (event.key.toLowerCase() === 'a' || 'c' || 'v')) {
            return; // Allow the event
        }

        const isDigit = /^[0-9]$/.test(event.key);
        const isAllowed = allowedKeys.includes(event.key);

        if (!isDigit && !isAllowed) {
            event.preventDefault();
        }
    }

    getAdminSiteUrls(callback) {
        this._commonServiceHelper.getAdminSiteUrls()
            .pipe(
      finalize(() => { }))
            .subscribe(
                (res: any) => {
                    if (res && res.data) {
                        callback(res.data)
                    }
                },
                (error: any) => {
                    this._toasterService.error(error.message, 'Error');
                }
            );

    }

    getLocation(callback) {
        if (this._appConstant.location && this._appConstant.location.length === 0) {
            //this._loaderService.display(true);
            this._commonServiceHelper.getLocationData()
                .pipe(
      finalize(() => {
                    //this._loaderService.display(false);
                }))
                .subscribe(
                    (res: any) => {
                        if (res && res.data) {
                            this._appConstant.location = res.data;
                            callback(res.data)
                        }
                    },
                    (error: any) => {
                        this._toasterService.error(error.message, 'Error');
                    }
                );
        } else {
            callback(this._appConstant.location)
        }
    }

    inputOnKeyDown(event) {
      if (!event.currentTarget.value.trim()) {
        event.preventDefault();
        event.currentTarget.value = '';
      }
    }

    formatTime(time) {
        let dateTime = new Date();
        if (time) {
            let times = time.split(':');
            if (times) {
                dateTime.setHours(parseInt(times[0]));
                dateTime.setMinutes(parseInt(times[1]));
                dateTime.setSeconds(parseInt(times[2]));
            }
        }
        return dateTime;
    }

    isValidTimeString(timeString: string): boolean {
        // Regex for 12-hour format (hh:mm AM/PM)
        const regex12Hour = /^(0?[1-9]|1[0-2]):[0-5][0-9] ?[APap][mM]$/;
        // Regex for 24-hour format (HH:mm)
        const regex24Hour = /^(?:[01]?\d|2[0-3]):[0-5][0-9]$/;
        return regex12Hour.test(timeString) || regex24Hour.test(timeString);
    }

    convertTimeToDate(timeString: string) : Date {
        let hours: number = 0;
        let minutes: number = 0;

        // Check if the time string contains AM/PM
        if (timeString)
        {
            if (timeString.includes('AM') || timeString.includes('PM')) {
            // Handle 12-hour format
            const [timePart, modifier] = timeString.split(' ');
            [hours, minutes] = timePart.split(':').map(Number);
        
            if (modifier === 'PM' && hours < 12) {
                hours += 12;
            } else if (modifier === 'AM' && hours === 12) {
                hours = 0;
            }
            } else if (timeString.includes(':')) {
            // Handle 24-hour format
            [hours, minutes] = timeString.split(':').map(Number);
            }
        }
    
        // Create a new Date object using the current date and the specified time
        const now = new Date();
        var dateTime = new Date(now.getFullYear(), now.getMonth(), now.getDate(), hours, minutes);        
        return dateTime;
    }
    
    getTimeIn12HourFormat(selectedTime: Date) {
        var am = "AM";
        if (selectedTime) {
          const hours = selectedTime.getHours();
          if (hours > 11) am = "PM";
          const minutes = selectedTime.getMinutes();
          const formattedTime = `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')} ${am}`;
          return formattedTime;
        }
    }

    getTimeIn24HourFormat(selectedTime: Date) {
        if (selectedTime) {
          const hours = selectedTime.getHours();
          const minutes = selectedTime.getMinutes();
          const formattedTime = `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}`;
          return formattedTime;
        }
    }

    formatTimeString(time: string): string {
        const [hour, minute] = time.split(':').map(Number);
        if (hour && minute) {
            const formattedHour = hour < 10 ? '0' + hour : hour.toString();
            return `${formattedHour}:${minute.toString().padStart(2, '0')}`;
        } else {
            return time;
        }
    }
}